
import { convertDecimalToHoursMinutes } from "./service"

function ReceiptTile({
    receipt
}) {

    console.log(receipt)

    return(
        <div className="w-full h-8 grid grid-cols-12 gap-x-3 bg-gray-100 flex items-center pl-2 pr-2 border-t-[1px] border-b-[1px] -mt-[1px] border-gray-300">
            <div className="col-span-2">
                <h2 className="text-sm w-full truncate pr-1">{receipt.user}</h2>
            </div>
            <div className="col-span-1">
                <h2 className="text-sm w-full truncate pr-1">{receipt.start_time.slice(0,10)}</h2>
            </div>
            <div className="col-span-1">
            <h2 className="text-sm w-full truncate pr-1">{convertDecimalToHoursMinutes(receipt.duration)}</h2>
            </div>
            <div className="col-span-1 flex items-center">
            <h2 className="text-sm truncate pr-1">${Number(receipt.price).toFixed(2)}</h2>
            {receipt.paid === "1" ? (
                    <h2 className="text-sm text-green-700 ml-1 font-semibold">Paid</h2>
                ) : ( 
                    <h2 className="text-sm text-red-700 ml-1 font-semibold">Not Paid</h2>
                )}
            </div>
            <div className="col-span-2 flex items-center">
                <h2 className="text-sm w-full truncate pr-1">{receipt.station_name}</h2>
            </div>
        </div>
    )
}

export default ReceiptTile